import { type DependencyList, useCallback, useState } from "react";

export default function useSubmit<Args extends Array<any>, T>(
    fn: (...args: Args) => Promise<T>,
    deps: DependencyList,
) {
    const [promise, setPromise] = useState<Promise<T> | null>(null);
    const callback = useCallback((...args: Args) => setPromise(fn(...args)), deps);
    return [callback, promise] as const;
}
